import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Lottie from 'lottie-react-web';
import dataAnalyses from './dataAnalyses.json';
import dataDesign from './dataDesign.json';
import dataResearch from './dataResearch.json';
import './features.scss';
import Title from '../../elements/title';

const Features = () => {
	const [feature, setFeature] = useState(1);
	useEffect(() => {
		// Update the document title using the browser API
		// console.log(feature);
	});
	let title;
	let description;
	let animation;
	if (feature == 1) {
		title = 'Compare';
		description =
			'Sustragil prüft die Vollständigkeit und Korrektheit von Sicherheitsdatenblättern automatisch auf Basis verschiedener Quellen, wie z.B. der ECHA- Datenbank . Nach Prüfung wird Ihnen eine validierte Klassifizierung angegeben.';
		animation = dataAnalyses;
	} else if (feature == 2) {
		title = 'Communicate';
		description =
			'Es gibt Unklarheiten oder Rückfragen zum Sicherheitsdatenblatt? Es fehlen Dokumente oder Informationen? Kontaktieren Sie den entsprechenden Ansprechpartner einfach direkt über Sustragil.';
		animation = dataDesign;
	} else {
		title = 'Analyse und Simulate';
		description =
			'Antizipieren der Auswirkungen von Gesetzesänderungen oder Veränderungen in der Rezeptur auf Ihr Produktportfolio, um Anpassungsszenarien zu simulieren und proaktiv Handlungsoptionen abzuleiten.';
		animation = dataResearch;
	}
	return (
		<section className='section-padding' id='features'>
			<Container>
				<Title
					title={
						<span>
							Sustragil entwickelt sich weiter, <br />
							jeden Tag.
						</span>
					}
					subtitle='Schon bald erwarten Sie die folgenden Funktionen.'
				/>
				<div className='features-body'>
					<div className='bar'>
						<button
							id={1}
							className={`segment ${feature == 1 && 'active'}`}
							onClick={(e) => {
								setFeature(e.target.id);
							}}
						>
							Compare
						</button>
						<button
							id={2}
							className={`segment ${feature == 2 && 'active'}`}
							onClick={(e) => {
								setFeature(e.target.id);
							}}
						>
							Communicate
						</button>
						<button
							id={3}
							className={`segment ${feature == 3 && 'active'}`}
							onClick={(e) => {
								setFeature(e.target.id);
							}}
						>
							Analyse
						</button>
					</div>
					<Row>
						<Col className='col-text' md={6}>
							<div>
								<h3>{title}</h3>
								<p>{description}</p>
							</div>
						</Col>
						<Col md={6} className='col-animation'>
							<Lottie
								options={{
									animationData: animation,
								}}
							/>
						</Col>
					</Row>
				</div>
			</Container>
		</section>
	);
};

export default Features;
